import axios from "axios";

/** Attach (or remove) the admin token on every API request. */
export const setAuthHeader = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  } else {
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers["Authorization"];
  }
};

/**
 * If the API rejects the admin token (expired / revoked), log out instead of
 * leaving the admin on a page where every save silently fails.
 */
export const installAuthInterceptor = (store, logoutAction) => {
  axios.interceptors.response.use(
    (r) => r,
    (error) => {
      const status = error && error.response && error.response.status;
      const isLogin = error && error.config && /\/login$/.test(error.config.url || "");
      if ((status === 401 || status === 403) && !isLogin && store.getState().adminLogin.adminInfo) {
        store.dispatch(logoutAction());
        sessionStorage.setItem("loginMessage", "Your session has expired. Please log in again.");
        if (window.location.pathname.startsWith("/admin")) window.location.assign("/login");
      }
      return Promise.reject(error);
    }
  );
};
